import React from "react";
import moment from "moment";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error react-polling ships no types and has no @types package; the
// default export is the polling component. Boundary-cast below to the props
// this component actually passes.
import ReactPollingUntyped from "react-polling";

export interface PollingRenderProps {
  isPolling: boolean;
  startPolling: () => void;
  stopPolling: () => void;
}

// Boundary cast for the untyped react-polling default export. Index signature
// admits the lib's other optional props (retryCount, method, backOffFactor, …).
const ReactPolling = ReactPollingUntyped as React.ComponentType<{
  url?: string;
  interval?: number;
  onSuccess?: (...args: unknown[]) => boolean;
  onFailure?: (...args: unknown[]) => boolean;
  promise?: (...args: unknown[]) => Promise<unknown>;
  render?: (props: PollingRenderProps) => React.ReactNode;
  [key: string]: unknown;
}>;

interface PromisePollerProps {
  interval: number;
  promiseToPoll: (...args: unknown[]) => Promise<unknown>;
  renderFunction?: (props: PollingRenderProps) => React.ReactNode;
  minutesToPollFor?: number;
}

interface PromisePollerState {
  startTime: moment.Moment;
}

function defaultRender() {
  return null;
}

export default class PromisePoller extends React.PureComponent<
  PromisePollerProps,
  PromisePollerState
> {
  static defaultProps = {
    renderFunction: defaultRender,
  };

  constructor(props: PromisePollerProps) {
    super(props);

    this.state = {
      startTime: moment(),
    };
  }

  _shouldContinuePolling = () => {
    if (!this.props.minutesToPollFor) {
      return true;
    }

    const currentTime = moment();
    const timePassedInMinutes = currentTime.diff(
      this.state.startTime,
      "minutes"
    );

    const minutesToPollForHasPassed =
      timePassedInMinutes >= this.props.minutesToPollFor;

    return !minutesToPollForHasPassed;
  };

  render() {
    return (
      <ReactPolling
        url={" "} // url empty string since we will always be polling against our graphql queries/action dispatchers
        interval={this.props.interval}
        onSuccess={() => {
          return this._shouldContinuePolling();
        }}
        onFailure={() => false}
        promise={this.props.promiseToPoll}
        render={this.props.renderFunction}
      />
    );
  }
}
